import { resolveTourStepsForRole } from "../resolveTourStepsForRole";

function copy(title, content) {
  return {
    Admin: { title, content },
    Manager: { title, content },
    "Sales Rep": { title, content },
  };
}

const STEP_DEFS = [
  {
    selector: '[data-tour="territory-edit-container"]',
    placement: "bottom",
    copy: copy(
      "Edit territory",
      "Update the territory name (Admin only), assign a manager, and review lead count. Save when you are done, or go back to the territories list."
    ),
  },
  {
    selector: '[data-tour="bulk-upload-leads-container"]',
    placement: "bottom",
    copy: copy(
      "Bulk upload leads",
      "Import many leads at once from a CSV or Excel file. Addresses are geocoded automatically, and you get a summary of created, skipped, and total leads in this territory."
    ),
  },
  {
    selector: '[data-tour="choose-file-button"]',
    placement: "top",
    copy: copy(
      "Choose file",
      "Pick a .csv, .xlsx, or .xls file from your computer. The selected file name appears next to this button before you upload."
    ),
  },
  {
    selector: '[data-tour="upload-file-button"]',
    placement: "top",
    copy: copy(
      "Upload file",
      "Start the import after you choose a file. Large files may take a few minutes while rows are validated and geocoded."
    ),
  },
  {
    selector: '[data-tour="add-leads-button"]',
    placement: "top",
    copy: copy(
      "Add individual lead",
      "Switch to this tab to enter one lead manually—name, address, status, assigned rep, and property details."
    ),
  },
];

export const TERRITORY_DETAIL_TOUR_STEPS = (role, options) =>
  resolveTourStepsForRole(STEP_DEFS, role, options);

export const TERRITORY_DETAIL_NEW_STEPS = () => [];
